'use client'
import { useContext, useRef, useState } from 'react'
import { Button, Dialog, DialogPanel, Disclosure, DisclosureButton, DisclosurePanel, } from '@headlessui/react'
import { Bars3Icon, XMarkIcon } from '@heroicons/react/24/outline'
import { ChevronDownIcon } from '@heroicons/react/20/solid'
import { motion, AnimatePresence } from "framer-motion"
import Logo from '../assets/logo.png'
import { NavLink, useLocation, useNavigate } from 'react-router-dom'
import { DContext } from '../context/DataContext'

const capabilities = [
    {
        name: 'Engineering & Platforms',
        topics: ['Web Development', 'Mobile Application Development', 'Product Development', 'Enterprise Systems']
    },
    {
        name: "Intelligence & Automation",
        topics: ['AI & Machine Learning', 'Intelligent Automation', 'Data & Analytics', 'Business Intelligence Systems']
    },
    {
        name: 'Design & Experience',
        topics: ['UI / UX Design', 'Brand Systems', 'Design Strategy', 'Digital Experience Design']
    },
    {
        name: 'Growth & Visibility',
        topics: ['Digital Marketing', 'Search Engine Optimization (SEO)', 'Performance Marketing', 'Growth Analytics']
    },
    {
        name: 'Connected Systems',
        topics: ['IoT Solutions', 'Hardware Integration', 'Monitoring & Control Systems', 'Smart Device Platforms']
    }
]

export default function Header() {
    const [openMega, setOpenMega] = useState(false)
    const [mobileMenuOpen, setMobileMenuOpen] = useState(false)
    const navigate = useNavigate()
    const { setOpenForm } = useContext(DContext)
    const locations = useLocation()

    const timeout = useRef(null)

    const handleEnter = () => {
        clearTimeout(timeout.current);
        setOpenMega(true);
    };

    const handleLeave = () => {
        timeout.current = setTimeout(() => {
            setOpenMega(false);
        }, 150);
    };

    return (

        <div className={`  sm:px-6 md:px-16 lg:px-24 md:mt-0 fixed sm:sticky top-0 z-50 shadow-sm w-full md:bg-primary-50 ${locations.pathname === '/capable' || locations.pathname === '/services' ? 'bg-white' : 'bg-white/80'}`}>
            <div className="relative ">

            </div>
            <header className="max-w-[1330px] mx-auto ">

                <nav className="flex items-center justify-between p-2 px-6 sm:px-6 lg:px-4">

                    {/* LOGO */}
                    <div className="flex lg:flex-1">
                        <a href="/" className="-m-1.5 p-1.5 flex gap-2 items-center">
                            <img src={Logo} alt="App Logo" className="h-[55px] md:h-[80px] w-auto" />
                        </a>
                    </div>

                    {/* MOBILE MENU BUTTON */}
                    <div className="flex lg:hidden">
                        <button
                            onClick={() => setMobileMenuOpen(true)}
                            className="-m-2.5 inline-flex items-center justify-center rounded-md p-2.5 text-gray-800"
                        >
                            <Bars3Icon className="size-8" />
                        </button>
                    </div>

                    {/* DESKTOP NAV */}
                    <div className='lg:flex lg:justify-around lg:gap-20 hidden'>

                        <NavLink
                            to="/"
                            className={({ isActive }) =>
                                `text-base font-medium tracking-[0.3px] ${isActive ? "text-primary-700" : "text-gray-900"}`
                            }
                        >
                            Home
                        </NavLink>

                        <NavLink
                            to="/about"
                            className={({ isActive }) =>
                                `text-base font-medium tracking-[0.3px] ${isActive ? "text-primary-700" : "text-gray-900"}`
                            }
                        >
                            About Us
                        </NavLink>

                        {/* CAPABILITIES MEGA MENU */}
                        <div
                            className=""
                            onMouseEnter={handleEnter}
                            onMouseLeave={handleLeave}
                        >
                            <NavLink
                                to="/capable"
                                className={({ isActive }) =>
                                    `text-base font-medium tracking-[0.3px] ${isActive ? "text-primary-700" : "text-gray-900"
                                    }`
                                }
                            >
                                Capabilities
                            </NavLink>

                            <AnimatePresence>
                                {openMega && (
                                    <motion.div

                                        initial={{ opacity: 0, y: -40 }}
                                        animate={{ opacity: 1, y: 0 }}
                                        exit={{ opacity: 0, y: 40 }}
                                        // transition={{ duration: 0.35, ease: "easeOut" }}
                                        className="absolute top-[90px] left-0 w-full bg-gray-50 shadow-xl z-50 overflow-hidden"
                                    >
                                        <div className="max-w-7xl mx-auto px-36 2xl:px-12 py-10">

                                            <h2
                                                className="text-2xl font-medium mb-8 cursor-pointer"
                                                onClick={() => {
                                                    setOpenMega(false);
                                                    navigate("/capable");
                                                }}
                                            >
                                                Our Services
                                            </h2>

                                            <div className="grid grid-cols-3 gap-32">

                                                {capabilities.map((item, index) => (

                                                    <div key={index}>

                                                        <h3
                                                            className="font-medium mb-5 cursor-pointer"
                                                            onClick={() => {
                                                                setOpenMega(false);
                                                                window.location.href = `/services?id=${Date.now()}#${item.name}`;
                                                            }}
                                                        >
                                                            {item.name}
                                                        </h3>

                                                        <ul className="space-y-4 text-gray-700">

                                                            {item.topics.map((topic, i) => (

                                                                <li
                                                                    key={i}
                                                                    onClick={() => {
                                                                        setOpenMega(false);
                                                                        window.location.href = `/services?title=${topic}#${item.name}`;
                                                                    }}
                                                                    className="cursor-pointer hover:text-primary-600 transition-colors duration-200"
                                                                >
                                                                    {topic}
                                                                </li>

                                                            ))}

                                                        </ul>

                                                    </div>

                                                ))}

                                            </div>

                                        </div>
                                    </motion.div>
                                )}
                            </AnimatePresence>
                        </div>

                        <NavLink
                            to="/product"
                            className={({ isActive }) =>
                                `text-base font-medium tracking-[0.3px] ${isActive ? "text-primary-700" : "text-gray-900"}`
                            }
                        >
                            Products
                        </NavLink>

                        {/* <NavLink
                            to="/Corporate"
                            className={({ isActive }) =>
                                `text-base font-medium tracking-[0.3px] ${isActive ? "text-primary-700" : "text-gray-900"}`
                            }
                        >
                        Corporate Training
                        </NavLink> */}

                    </div>

                    {/* CTA BUTTON */}
                    <div className="hidden lg:flex lg:flex-1 lg:justify-end">

                        <Button
                            className="w-[100px] h-[38px] text-white text-base bg-gradient-to-r from-primary-900 to-secondary-600 rounded-lg"
                            onClick={() => setOpenForm(openForm => !openForm)}
                        >
                            Let's Talk
                        </Button>

                    </div>

                </nav>


                {/* MOBILE MENU */}
                <Dialog open={mobileMenuOpen} onClose={setMobileMenuOpen} className="lg:hidden">

                    <div className="fixed inset-0" />

                    <DialogPanel className="fixed inset-y-0 right-0 z-50 w-full overflow-y-auto bg-white p-2 sm:p-6 sm:max-w-sm sm:ring-1 sm:ring-gray-900/10">

                        <div className="flex items-center justify-between">

                            <a href="/" className="-m-1.5 p-1.5 flex gap-1 items-center">
                                <img src={Logo} className="h-[70px] w-auto" alt='SAN Logo' />
                            </a>

                            <button
                                onClick={() => setMobileMenuOpen(false)}
                                className="-m-2.5 rounded-md p-2.5 text-gray-700"
                            >
                                <XMarkIcon className="size-6" />
                            </button>

                        </div>

                        <div className="mt-6 flow-root">

                            <div className="-my-6 divide-y divide-gray-500/10">

                                <div className="space-y-2 py-6">

                                    <a href="/" className="-mx-3 block rounded-lg px-3 py-2 text-base font-medium text-gray-900 hover:bg-gray-50">
                                        Home
                                    </a>

                                    <a href="/about" className="-mx-3 block rounded-lg px-3 py-2 text-base font-medium text-gray-900 hover:bg-gray-50">
                                        About Us
                                    </a>

                                    {/* MOBILE CAPABILITIES */}
                                    <Disclosure as="div" className="-mx-3">

                                        <DisclosureButton className="group flex w-full items-center justify-between rounded-lg py-2 pr-3.5 pl-3 text-base font-medium text-gray-900 hover:bg-gray-50">
                                            Capabilities
                                            <ChevronDownIcon className="size-5 group-data-open:rotate-180" />
                                        </DisclosureButton>

                                        <DisclosurePanel className="mt-2 space-y-2">

                                            {capabilities.map((item) => (

                                                <Disclosure key={item.name} as="div">

                                                    <DisclosureButton
                                                        onClick={() => {
                                                            setOpenMega(false)
                                                            navigate(`/services#${item.name}`)
                                                        }}
                                                        className="group flex w-full items-center justify-between rounded-lg py-2 pr-3 pl-6 text-sm font-medium text-gray-900 hover:bg-gray-50">
                                                        {item.name}
                                                        <ChevronDownIcon className="size-4 group-data-open:rotate-180" />
                                                    </DisclosureButton>

                                                    <DisclosurePanel className="mt-1 space-y-1 pl-8">

                                                        {item.topics.map((topic, i) => (

                                                            <a
                                                                key={i}
                                                                // onClick={() => {
                                                                //     setOpenMega(false)
                                                                //     window.location.href = ;
                                                                // }}
                                                                href={`/services?title=${topic}#${item.name}`}
                                                                className="block rounded-lg py-2 pr-3 text-sm text-gray-700 hover:bg-gray-50"
                                                            >
                                                                {topic}
                                                            </a>

                                                        ))}

                                                    </DisclosurePanel>

                                                </Disclosure>

                                            ))}

                                        </DisclosurePanel>

                                    </Disclosure>

                                    <a href="/product" className="-mx-3 block rounded-lg px-3 py-2 text-base font-semibold text-gray-900 hover:bg-gray-50">
                                        Products
                                    </a>

                                </div>

                                <div className="py-6 flex justify-center">

                                    <Button
                                        className="w-[150px] h-[38px] text-white text-base bg-gradient-to-r from-primary-900 to-secondary-600 rounded-lg"
                                        onClick={() => setOpenForm(openForm => !openForm)}

                                    >
                                        Let's Talk
                                    </Button>

                                </div>

                            </div>

                        </div>

                    </DialogPanel>

                </Dialog>

            </header>
            {/* <div className=" w-full ">
                <div className="flex items-center justify-center py-2 ">
                    <p className="text-xs md:text-sm text-primary-900 text-center font-semibold">
                        We are currently enhancing our website experience.
                        <span className="text-primary-900 font-medium">
                            {" "}For service inquiries, project consultations, or partnership opportunities, please contact us via email.
                        </span>
                    </p>
                </div>
            </div> */}

        </div>

    )
}
